module.exports = __webpack_public_path__ + "img/10013.0338eec9.jpg";